import { useState } from 'react'
import { Image } from 'react-bootstrap'
import { ArrowLeft, ArrowRight } from 'phosphor-react'
import styles from './styles.module.css'

const RequestDeliveryImagesCarousel = ({ images }) => {
  const [currentImageIdx, setCurrentImageIdx] = useState(0)

  if (!images || images.length === 0) return null

  return (
    <div className={styles.carouselContainer}>
      <div className={styles.carouselThumbnails}>
        {images.map((img, idx) => (
          <img
            key={img.delivery_image_url}
            src={img.delivery_image_url}
            alt={`Entrega ${idx + 1}`}
            className={`${styles.thumbnail} ${idx === currentImageIdx ? styles.thumbnailActive : ''}`}
            onClick={() => setCurrentImageIdx(idx)}
          />
        ))}
      </div>
      <div className={styles.carouselImageWrapper}>
        <button
          className={styles.carouselArrow}
          disabled={currentImageIdx === 0}
          onClick={() => setCurrentImageIdx((idx) => Math.max(0, idx - 1))}
          aria-label="Imagem anterior"
        >
          <ArrowLeft size={24} weight="bold" />
        </button>
        <Image
          style={{ cursor: 'pointer', margin: '0 16px', borderRadius: '8px' }}
          fluid={true}
          width={'100%'}
          src={images[currentImageIdx].delivery_image_url}
          onClick={() => window.open(images[currentImageIdx].delivery_image_url, '_blank')}
        />
        <button
          className={styles.carouselArrow}
          disabled={currentImageIdx === images.length - 1}
          onClick={() => setCurrentImageIdx((idx) => Math.min(images.length - 1, idx + 1))}
          aria-label="Próxima imagem"
        >
          <ArrowRight size={24} weight="bold" />
        </button>
      </div>
    </div>
  )
}

export default RequestDeliveryImagesCarousel
